<template>
  <!-- 图片查看组件 -->
  <div id="img_view" v-if="dialogVisible">
    <div class="cover" @click="dialogVisible = false"></div>
    <div class="change_button">
      <div class="content">
        <i class="el-icon-close" @click="dialogVisible = false"></i>
        <template v-if="imgList.length > 1">
          <i class="el-icon-arrow-left" @click="changeImg('back')"></i>
          <i class="el-icon-arrow-right" @click="changeImg('next')"></i>
        </template>
      </div>
    </div>
    <div class="img_view">
      <el-image
        :src="ImgUrl + imgList[img_index]"
        alt
        @mousewheel="rollImg"
        ref="bigImage"
      ></el-image>
      <p class="hint">图{{ img_index + 1 }}</p>
    </div>
  </div>
</template>

<script>
/**
 * 全屏图片查看组件
 * 功能：支持左右切换、鼠标滚轮缩放、点击遮罩关闭，图片地址前缀由外部 ImgUrl prop 传入
 */
import serverPath from "@/config/config.js";
export default {
  props: {
    imgList: Array, //父元素传过来的图片列表
    imgIndex: { type: Number, default: 0 }, //父元素打开的图片下标
    dialog: { type: Boolean, default: false }, //显示状态
    ImgUrl: { type: String, default: "" },
  },
  watch: {
    //监听图片查看打开时图片默认显示为选中的图片
    dialogVisible(val) {
      if (val) {
        this.img_index = this.imgIndex;
        this.img_show = this.imgList[this.imgIndex];
        //移除图层下的滚动条
        document.body.style.overflow = "hidden";
      } else {
        //关闭时打开滚动条
        document.body.style.overflow = "auto";
      }
    },
  },
  computed: {
    // 弹窗显示状态（与 dialog prop 双向同步）
    dialogVisible: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit("update:dialog", val);
      },
    },
  },
  data() {
    return {
      img_index: null, //显示的图片下标
      img_show: null, //正在展示的图片信息
    };
  },
  mounted() {
    // const env = serverPath.env;
    // if (env === "test" || env === "dev" || env === "localhost") {
    //   this.ImgUrl = serverPath.serverPath.server + "/";
    // } else {
    //   this.ImgUrl = "http://images.delaman168.com/crm/";
    // }
  },
  methods: {
    //图片切换
    changeImg(type) {
      //根据图片列表获取最大值
      let max = this.imgList.length - 1;
      //下一张
      if (type == "next") {
        this.img_index++;
        if (this.img_index > max) {
          this.img_index = 0;
        }
      }
      //上一张
      if (type == "back") {
        this.img_index--;
        if (this.img_index < 0) {
          this.img_index = max;
        }
      }
      this.img_show = this.imgList[this.img_index];
    },
    //缩放变大图片
    rollImg(event) {
      /* 获取当前页面的缩放比
            若未设置zoom缩放比，则为默认100%，即1，原图大小
        */
      var zoom = parseInt(this.$refs.bigImage.style.zoom) || 100;
      /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom
            wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动
        */
      zoom += event.wheelDelta / 12;
      /* 最小范围 和 最大范围 的图片缩放尺度 */
      if (zoom >= 20 && zoom < 250) {
        this.$refs.bigImage.style.zoom = zoom + "%";
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.change_button {
  width: 100%;
  z-index: 99;
  position: fixed;
  top: 12%;
  text-align: center;
  .content {
    background: rgba(0, 0, 0, 0.253);
    display: inline-block;
    padding: 5px;
    text-align: center;
    i {
      opacity: 0.8;
      cursor: pointer;
      color: white;
      font-size: 27px;
      font-weight: bold;
      margin: 0 20px;
      transition: transform 0.3s;
      &:hover {
        opacity: 1;
        text-shadow: 0 0 3px white;
      }
      &:active {
        opacity: 1;
        transform: scale(0.9);
      }
    }
  }
}
#img_view {
  z-index: 9999;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .cover {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: black;
    opacity: 0.7;
    z-index: -1;
  }
  .img_view {
    position: relative;
    padding: 10px;
    img {
      height: 100%;
      min-height: 350px;
    }
    .hint {
      position: absolute;
      bottom: -40px;
      width: 100%;
      font-size: 13px;
      color: white;
      text-align: center;
    }
  }
}
</style>